<script lang="ts">
	import Page from '$lib/components/Page.svelte';
</script>

<Page>
	<main class="blog-post">
		<slot />
	</main>
</Page>

<style lang="postcss">
	:global(.blog-post) {
		margin: auto;
		padding: 2rem;
		line-height: 1.6;
		@apply space-y-8;
	}

	:global(.blog-post section) {
		@apply space-y-4;
	}

	:global(.blog-post h1) {
		@apply text-4xl font-bold;
	}

	:global(.blog-post h2) {
		@apply text-xl font-bold;
	}

	:global(.blog-post h3) {
		@apply text-lg font-bold;
	}

	:global(.blog-post ul) {
		margin-top: 1rem;
	}

	:global(.blog-post li) {
		margin-bottom: 0.5rem;
	}

	:global(.blog-post a) {
		@apply link;
	}

	:global(.blog-post blockquote) {
		@apply border-l-4 border-neutral-300 pl-4;
	}
</style>
